<template>
  <div class="personal">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="意见反馈" fixed >
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
      <van-icon slot="right" class="iconfont icon-zhankai" @click="onClickRight()"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav title="意见反馈"> </GlobTopNav>

    <div class="van-content bg-fff">
      <p>您有什么问题或建议想对我们说的？</p>
      <div style="margin: 0">
        <div class="nicknameCont">
          <textarea
            v-model="feedcont"
            placeholder="您的宝贵意见，就是我们的前进动力！（字数限制在500字以内）"
          ></textarea>
          <!--<van-field  type="textarea"   />-->
        </div>
      </div>
    </div>
    <van-button class="submint" @click="feedback()">提交</van-button>
  </div>
</template>

<script>
import TopNav from "../../../components/topnav";
export default {
  name: "index",
  components: { TopNav },
  props: ["configData", "userConfig"],
  data() {
    return {
      feedcont: "",
      btn: false
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    feedback: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (this.btn == false) {
        this.btn = true;
        if (this.feedcont == "") {
          this.$dialog
            .alert({
              title: "提示",
              message: "输入内容不能为空！"
            })
            .then(() => {
              this.btn = false;
              // on close
            });
        } else if (this.feedcont.length > 500) {
          this.$dialog
            .alert({
              title: "提示",
              message: "输入内容不能超过500个字！"
            })
            .then(() => {
              // on close
              this.btn = false;
            });
        } else {
          this.$api.post(
            "user/user/opinion",
            { id_example: mallid, token_user: isUser, content: this.feedcont },
            res => {
              if (res.data.code == "100") {
                this.$toast("感谢您反馈的宝贵意见！");
                this.feedcont = "";
                this.btn = false;
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                  this.btn = false;
                } else {
                  this.btn = false;
                  this.$toast(res.data.message);
                }
              }
            }
          );
        }
      }
    }
  },
  mounted() {
    $("body").css("background", "#fff");
  },
  destroyed: function() {
    $("body").css("background", "#EFF3F6");
  }
};
</script>

<style lang="less" scoped>
.personal {
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;

  .van-content {
    width: 100vw;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 0.3rem 0 0.3rem;

    p {
      padding: 0.36rem 0;
      font-size: 0.28rem;
      font-weight: bold;
      color: rgba(38, 38, 38, 0.8);
      line-height: 0.48rem;
      border-bottom: 0.02rem solid #f5f5f5;
    }
  }

  .nicknameCont {
    width: 100%;
    margin-top: 0.2rem;
    textarea {
      width: 100%;
      min-height: 2rem;
      border: none;
      resize: none;
    }
  }

  .submint {
    width: calc(100vw - 1.2rem);
    height: 0.96rem;
    margin-left: 0.6rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.42rem;
    margin-top: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/help/feedback.vue